module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ky-89bdd0e80629988fa21053c5297ba7f5.svg";